import DefaultLayout from '../../../layout/DefautlLayout';
import Header from '../../../components/header/Header';
import { Link } from 'react-router-dom';
import TreatmentIntroBanner from '../../../components/treatmentBanner/treatmentBanner';

const PolynucleotidesPage = () => {
	const prices = [{ label: 'Treatment', value: '€250/£170' }];
	return (
		<DefaultLayout>
			<Header />
			<div id="Content">
				<div className="content_wrapper clearfix">
					<div className="sections_group">
						<div className="extra_content">
							<TreatmentIntroBanner
								title="PolyNucleotides"
								description="Polynucleotide treatments are regenerative injectables that boost collagen, improve hydration, and support skin repair—ideal for under-eyes, face, neck, and other delicate areas."
								quote=" Beauty is power, confidence is its foundation. "
								backgroundImage="/assets/images/banners/treatment-xl-2.png"
							/>

							<div className="section mcb-section" id="image" style={{ paddingBottom: '70px' }}>
								<div className="section_wrapper mcb-section-inner">
									<div className="wrap mcb-wrap one valign-top clearfix">
										<div className="mcb-wrap-inner">
											<div className="column mcb-column one-third column_image">
												<div className="image_frame image_item scale-with-grid aligncenter has_border hrmargin_b_30">
													<div className="image_wrapper">
														<div className="mask"></div>
														<img
															className="scale-with-grid"
															src="/assets/images/treatments/polynucleotides.jpg"
															alt="Polynucleotides Treatment"
															width="960"
															height="960"
														/>
													</div>
												</div>
											</div>

											<div className="column mcb-column two-third column_column">
												<div className="column_attr clearfix">
													<h4>How It Works</h4>
													<p>
														Polynucleotides are DNA-derived molecules that act as skin cell stimulators. When injected into the
														skin, they encourage fibroblast activity, improve hydration, promote tissue regeneration, and enhance
														skin texture by supporting collagen and elastin production.
													</p>

													<h4>What to Expect</h4>
													<ul>
														<li>Treatment time: approx. 30 minutes in a clinical setting.</li>
														<li>Recommended: 2-3 sessions spaced 2-4 weeks apart, depending on skin needs.</li>
														<li>Gradual improvement over weeks—skin becomes plumper, brighter, and more resilient.</li>
														<li>Minimal downtime; mild redness or swelling may occur post-treatment.</li>
													</ul>

													<h4>Benefits</h4>
													<ul>
														<li>Stimulates true skin regeneration and hydration</li>
														<li>Improves tone, elasticity, and firmness</li>
														<li>Effective for under-eye circles, dullness, fine lines, and crepey texture</li>
													</ul>

													<h4>Possible Side Effects</h4>
													<ul>
														<li>Mild redness, swelling or tenderness at injection sites</li>
														<li>Temporary bruising, generally resolving within a few days</li>
														<li>Rare allergic response; a patch test can be arranged if required</li>
													</ul>
												</div>
											</div>

											<div className="column mcb-column one column_column">
												<div className="column_attr clearfix">
													<div className="column one column_pricing_item">
														<div className="pricing-box custom-pricing-box pricing-box-table pricing-box-featured">
															<div className="plan-header">
																<h3>Pricing</h3>
															</div>
															<div className="plan-inside clearfix">
																<hr className="bg-theme" />
																<ul>
																	{prices.map(({ label, value }, idx) => (
																		<li key={idx} className="clearfix" style={{ paddingLeft: '5%', paddingRight: '5%' }}>
																			<div>
																				<strong>{label}</strong>
																			</div>
																			<div>{value}</div>
																		</li>
																	))}
																</ul>
																<hr className="bg-theme" />
															</div>
															<div className="plan-footer">
																<Link to="/book-now" className="button button_left button_theme button_js">
																	<span className="button_icon">
																		<i className="icon-basket"></i>
																	</span>
																	<span className="button_label">BOOK NOW</span>
																</Link>
															</div>
														</div>
													</div>
												</div>

												<div className="column mcb-column one column_divider">
													<hr className="no_line" />
												</div>

												<div className="column one column_slider">
													<div className="column_attr clearfix hrmargin_b_60">
														<h2 className="hrmargin_b_60" style={{ textAlign: 'center' }}>
															Results
														</h2>
														<div className="content_slider">
															<ul className="content_slider_ul">
																<li className="content_slider_li_1">
																	<img
																		width="100%"
																		height="auto"
																		src="/assets/images/treatments/polynucleotides-result.jpg"
																		alt="Polynucleotides Result"
																		className="scale-with-grid wp-post-image"
																	/>
																</li>
															</ul>
														</div>
													</div>
												</div>

												<div className="column mcb-column one column_divider">
													<hr className="no_line" />
												</div>

												<div className="column mcb-column one column_column">
													<div className="column_attr clearfix">
														<h2 className="hrmargin_b_60" style={{ textAlign: 'center' }}>
															After-Care
														</h2>
														<ul>
															<li>
																Avoid touching or applying makeup for at least 6 hours post-treatment to reduce contamination
																risk.
															</li>
															<li>Refrain from strenuous exercise, sauna, or facial treatments for 48 hours.</li>
															<li>Apply cold compresses if mild swelling occurs. Keep skin clean and well hydrated.</li>
															<li>Use gentle products and avoid exfoliating acids or retinoids until any redness subsides.</li>
														</ul>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</DefaultLayout>
	);
};

export default PolynucleotidesPage;
